import { initWorkItemsRoot } from '../../../work_items/index.js?vue3';
import { initJiraIssuesImportStatusRoot } from '../../../work_items/list/index.js?vue3';

initWorkItemsRoot();
initJiraIssuesImportStatusRoot();
